import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  info\@on24.ee

  <span style="color:#85c1dc;">**FI:**</span>
  info\@on24.fi

  <span style="color:#85c1dc;">**RU:**</span>
  info\@on24.ee
*/
/* @__NO_SIDE_EFFECTS__ */
const m1950 = msg(
  mf`info@on24.ee`,
  mf`info@on24.fi`,
  mf`info@on24.ee`,
)

export { m1950 as 'w.module.product.ask_price.mail.to' }